import styled from "@emotion/styled"

import { Link } from "components/core/Link"
import { rgba } from "utils/cssUtils"

export const Container = styled.div`
  background-color: ${p => rgba(p.theme.colors.primaryExtremelyLight, 0.5)};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 25px 40px;
  margin: 60px 0 0;
`

export const AuthorImg = styled.img`
  width: 120px;
  height: 120px;
  border: 5px solid ${p => rgba(p.theme.colors.primaryMedium, 0.1)};
  border-radius: 50%;
  margin: 0 auto;
`

export const AuthorName = styled.h1`
  ${p => p.theme.typography.special.size_24px.bold()}
  color: ${p => p.theme.colors.primaryMedium};
  max-width: 568px;
  margin: 30px auto 14px;
`

export const Description = styled.p`
  ${p => p.theme.typography.standard.size_18px.normal()}
  color: ${p => rgba(p.theme.colors.primaryMedium, 0.8)};
  margin: 0;
  text-align: center;
  max-width: 540px;
`

export const SocialMedia = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 40px auto 14px;

  svg {
    cursor: pointer;
    opacity: 1;

    &:hover {
      opacity: 0.9;
    }
  }
`

export const LinkItem = styled(Link)`
  ${p => p.theme.typography.standard.size_16px.normal()}
  color: ${p => rgba(p.theme.colors.primaryMedium, 0.7)};
  text-decoration: none;

  :visited {
    color: ${p => rgba(p.theme.colors.primaryMedium, 0.7)};
  }
`

export const FollowText = styled.p`
  ${p => p.theme.typography.standard.size_16px.normal()}
  color: ${p => rgba(p.theme.colors.primaryMedium, 0.5)};
  line-height: 1.5;
  margin: 0 auto;
  text-align: center;
`
